import { useEffect, useState } from "react";
import client from "../../utils/client";
import {
  Box,
  Button,
  Flex,
  Input,
  Select,
  SimpleGrid,
  Skeleton,
  Text,
} from "@chakra-ui/react";
import VideoCard from "../VideoCard";
import { useAuth } from "../../context/AuthContext";

const OtherVideos = () => {
  const [videos, setVideos] = useState();
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearchTerm, setDebounceSearchTerm] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [tags, setTags] = useState([]);
  const auth = useAuth();

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await client.get("/videos/tags");
        setTags(response.data);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceSearchTerm, selectedTag]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.length >= 5) {
        setDebounceSearchTerm(searchTerm);
      }
    }, 3000);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    setIsLoadingPage(true);
    const request = async () => {
      const response = await client.get(
        `/videos?page=${currentPage}&search=${debounceSearchTerm}&tag=${selectedTag}`
      );
      setVideos(response.data.videoItems);
      setCurrentPage(response.data.currentPage);
      setTotalPages(
        Array.from({ length: response.data.totalPages }, (_, index) => index + 1)
      );
    };
    request().then(() => setIsLoadingPage(false));
  }, [currentPage, debounceSearchTerm, selectedTag]);

  return (
    <Skeleton isLoaded={!isLoadingPage}>
      {/* Search bar */}
      <Flex mb={6} gap={3} flexDir={["column", "row"]} maxW="700px">
        <Input
          placeholder="Pesquisar vídeos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          bg="white"
          borderColor="gray.300"
          _focus={{ borderColor: "green.400", boxShadow: "0 0 0 1px var(--chakra-colors-green-400)" }}
        />
        <Select
          placeholder="Filtrar por tag"
          value={selectedTag}
          onChange={(e) => setSelectedTag(e.target.value)}
          bg="white"
          borderColor="gray.300"
          minW="180px"
          _focus={{ borderColor: "green.400" }}
        >
          {tags.map((tag) => (
            <option key={tag} value={tag}>{tag}</option>
          ))}
        </Select>
        {(debounceSearchTerm || selectedTag) && (
          <Button
            onClick={() => {
              setSearchTerm("");
              setDebounceSearchTerm("");
              setSelectedTag("");
            }}
            variant="outline"
            colorScheme="gray"
            flexShrink={0}
          >
            Limpar
          </Button>
        )}
      </Flex>

      {/* Video grid — fixed columns, all cards same width */}
      <SimpleGrid columns={[1, 2, 3, 4]} spacing={5}>
        {videos &&
          videos.map((el) => {
            if (Number(auth.user.symbolicGrade) >= Number(el.gradeRestriction)) {
              return <VideoCard video={el} key={el.videoId} />;
            }
            return null;
          })}
      </SimpleGrid>

      {videos && videos.length === 0 && (
        <Box textAlign="center" py={12} color="gray.400">
          <Text fontSize="1.1rem">Nenhum vídeo encontrado.</Text>
        </Box>
      )}

      {/* Pagination */}
      {totalPages.length > 1 && (
        <Flex gap={2} mt={8} alignItems="center" justifyContent="center">
          {totalPages.map((page) =>
            page === currentPage ? (
              <Box
                key={page}
                w="36px" h="36px"
                borderRadius="50%"
                bg="green.500"
                color="white"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight={700}
                fontSize="0.9rem"
              >
                {page}
              </Box>
            ) : (
              <Button
                key={page}
                colorScheme="green"
                size="sm"
                variant="outline"
                borderRadius="50%"
                w="36px" h="36px"
                p={0}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </Button>
            )
          )}
        </Flex>
      )}
    </Skeleton>
  );
};
export default OtherVideos;
